<script lang="ts">
	import arrowIcon from "@core/assets/icons/arrow.svg?raw";
	import Formatted from "./common/Formatted.svelte";
	import Heading from "./common/Heading.svelte";
	import Icon from "./common/Icon.svelte";

	const { href, image, title, text, cta }: { href: string; image: string; title: string; text: string; cta: string } =
		$props();
</script>

<article class="group/offer-card flex flex-col">
	<a {href} class="contents cursor-pointer">
		<div class="relative w-full aspect-[3/2] rounded-2xl overflow-hidden bg-fcrlightgray-400">
			<img
				src={image}
				alt=""
				width={800}
				height={533}
				loading="lazy"
				class="absolute inset-0 size-full object-cover transition-transform duration-500 group-hover/offer-card:scale-105"
			/>
		</div>
		<Heading
			level={3}
			text={title}
			class={[
				"font-antipol text-fcrdarkgray text-base md:text-1.5xl mt-4 md:mt-6 transition-colors",
				"group-hover/offer-card:text-fcrbrown group-hover/offer-card:underline",
			]}
		/>
		<p class="mt-2 text-sm/normal sm:text-base text-fcrgray">
			<Formatted {text} />
		</p>
		<span
			class={[
				"mt-4 inline-flex w-fit items-center gap-2 text-sm/normal sm:text-base font-medium text-fcrdarkgray",
				"underline underline-offset-4 decoration-1 transition-colors group-hover/offer-card:text-fcrbrown",
			]}
		>
			<Formatted text={cta} />
			<Icon icon={arrowIcon} class="size-3.5" />
		</span>
	</a>
</article>
